// external
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';

// models, types
import { CallToActionPosition } from '@/interfaces/CallToActionTypes';
import { VuexAction } from '@/@types/index.d';

// store
import {
	GET_THIRD_TAB_CLICK_REPORT,
	SEND_REPORT,
	GET_FOOTER_BUTTON_CLICKED_REPORT,
} from '@/store/types';
import { IReport } from '@/interfaces/IReport';

@Component({})
export default class CustomLink extends Vue {
	gamRedirect: string;

	@Prop({ required: true }) label!: string;

	@Prop({ required: true }) uri!: string;

	@Prop({ required: true }) position!: CallToActionPosition;

	@Getter(GET_THIRD_TAB_CLICK_REPORT) getThirdTabClickReport!: IReport;

	@Getter(GET_FOOTER_BUTTON_CLICKED_REPORT)
	getFooterButtonClickedReport!: IReport;

	@Action(SEND_REPORT) sendReport!: VuexAction<IReport>;

	get fullUri() {
		return this.gamRedirect
		? `${this.gamRedirect}${encodeURIComponent(this.uri)}`
		: this.uri;
	}

	// eslint-disable-line class-methods-use-this
	handleClick() {
		const report = this.getThirdTabClickReport;
		report.mxrThirdTabButtonClicked!.button = {
			label: this.label,
			type: 'customLink',
			url: this.fullUri,
		};
		this.sendReport(report);
		this.sendReport(this.getFooterButtonClickedReport);
	}

	created() {
        if (window.sm_params) {
			this.gamRedirect = window.sm_params.smcuu
				? window.sm_params.smcuu
				: window.sm_params.smcue;
		}
    }
}
